import Card from './Card';

export default function StatCard({
  title,
  value,
  subtitle,
  icon,
  variant = 'default',
  valueColor,
  size = 'default',
  className = ''
}) {

  // Value color styles
  const valueColors = {
    primary: 'text-brand-primary',
    success: 'text-success-dark dark:text-success',
    danger: 'text-danger-dark dark:text-danger',
    warning: 'text-warning-dark dark:text-warning',
    purple: 'text-purple-600',
    blue: 'text-blue-600',
    default: 'text-text-primary-light dark:text-text-primary'
  };

  const colorClass = valueColor ? valueColors[valueColor] || valueColor : valueColors.default;

  // Size variants
  const isCompact = size === 'compact';
  const padding = isCompact ? 'sm' : 'md';
  const titleClass = isCompact ? 'text-xs' : 'text-sm';
  const valueClass = isCompact ? 'text-2xl' : 'text-4xl';
  const subtitleClass = isCompact ? 'text-xs mt-1' : 'text-sm mt-2';
  const iconSize = isCompact ? 'h-5 w-5' : 'h-6 w-6';

  return (
    <Card variant={variant} padding={padding} className={className}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h3 className={`${titleClass} font-semibold text-text-secondary-light dark:text-text-secondary mb-2`}>
            {title}
          </h3>
          <p className={`${valueClass} font-bold ${colorClass}`}>
            {value}
          </p>
          {subtitle && (
            <p className={`${subtitleClass} text-text-muted-light dark:text-text-muted`}>
              {subtitle}
            </p>
          )}
        </div>
        {icon && (
          <div className={`ml-4 ${iconSize}`}>
            {icon}
          </div>
        )}
      </div>
    </Card>
  );
}
